import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Icon } from '@vectord/components';

import {
  BULK_REMOVE_SUPER_BATCHES_MODAL_STAGES,
  setRemoveSuperBatchesModalStage,
} from 'features/classCreation';
import BulkRemoveSuperBatchesButton from '../BulkRemoveSuperBatchesButton';
import Field from 'components/Field';
import SectionHeading from 'components/SectionHeading';
import SelectedSbatGroupsForBulkUpdate from '../SelectedSbatGroupsForBulkUpdate';
import styles from './BulkRemoveSuperBatchesModalConfirmStage.module.scss';
import ToggleChip from 'components/ToggleChip';

function BulkRemoveSuperBatchesModalConfirmStage({
  selectedSuperBatches,
  setSelectedSuperBatches,
}) {
  const dispatch = useDispatch();
  const isButtonDisabled = selectedSuperBatches.length === 0;

  const handleRemoveSelectedSuperBatches = useCallback(
    (superBatchId) => {
      setSelectedSuperBatches((prevSelectedSuperBatches) =>
        prevSelectedSuperBatches.filter((sb) => sb.value !== superBatchId)
      );
    },
    [setSelectedSuperBatches]
  );

  const handleBackClick = useCallback(() => {
    dispatch(
      setRemoveSuperBatchesModalStage(
        BULK_REMOVE_SUPER_BATCHES_MODAL_STAGES.select
      )
    );
  }, [dispatch]);

  return (
    <div className={styles.root}>
      <SectionHeading
        title={
          <>
            <Icon
              name="minus-circle"
              className="primary m-r-xxs"
            />
            Remove Batch/es
          </>
        }
        titleClassName={styles.heading}
        className={styles.sectionHeading}
      />
      <SelectedSbatGroupsForBulkUpdate />
      <Field
        label="Batches selected to be removed"
        labelClassName={styles.selectBatchesText}
      >
        {selectedSuperBatches.map((superBatch) => (
          <ToggleChip
            key={superBatch.value}
            className={styles.toggleChip}
            isAdded
            label={superBatch.label}
            onRemove={() => handleRemoveSelectedSuperBatches(superBatch.value)}
          />
        ))}
        <ToggleChip
          className={styles.defaultToggleChip}
          label="Add more Batches"
          onAdd={handleBackClick}
        />
      </Field>
      <div className={styles.text}>
        The above selected batches will be removed.
      </div>
      <BulkRemoveSuperBatchesButton
        disabled={isButtonDisabled}
        selectedSuperBatches={selectedSuperBatches}
      />
    </div>
  );
}

export default BulkRemoveSuperBatchesModalConfirmStage;
